import { gql } from '@apollo/client';

export const OrganizationNoteFieldsFragment = gql`
  fragment OrganizationNoteFields on OrganizationNoteModel {
    id
    content
    createdAt
    updatedAt
    createdBy {
      id
      fullName
      username
    }
  }
`;
